import { render, staticRenderFns } from "./SatisForm.vue?vue&type=template&id=09c352f8&scoped=true"
import script from "./SatisForm.vue?vue&type=script&lang=ts"
export * from "./SatisForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c352f8",
  null
  
)

export default component.exports